import { Injectable } from '@angular/core';
import {Device, DeviceInfo} from '@capacitor/device';


@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private _info: DeviceInfo = null;
  constructor() { }

  public async init(): Promise<void> {
    this._info = await Device.getInfo();
  }

  get info(): DeviceInfo {
    return this._info;
  }
}
